import { render, staticRenderFns } from "./crossCertification.vue?vue&type=template&id=44dea568&scoped=true&"
import script from "./crossCertification.vue?vue&type=script&lang=js&"
export * from "./crossCertification.vue?vue&type=script&lang=js&"
import style0 from "./crossCertification.vue?vue&type=style&index=0&id=44dea568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dea568",
  null
  
)

export default component.exports